import template from './passenger-seat.html';

const DIRECTIVE_NAME = PassengerSeat.DIRECTIVE_NAME = 'ktPassengerSeat';

export default function PassengerSeat() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: PassengerSeatController,
        controllerAs: '$ctrl',
        scope: {
            traveller: `=${DIRECTIVE_NAME}`,
            selectedSeats: `=${DIRECTIVE_NAME}SelectedSeats`,
            flight: `=${DIRECTIVE_NAME}Flight`,
            tripDetails: `=${DIRECTIVE_NAME}TripDetails`,
            map: `=${DIRECTIVE_NAME}Map`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => {
            $ctrl.$onInit();
        },
    };
}

export function PassengerSeatController(
    $scope,
    userService,
    tripTravellerAllocationPassengerService,
    selectedSeatsService,
    amadeusSeatService,
    amadeusSeatmapService,
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
        deselectSeat,
    });

    function $onInit() {
        vm.rs = userService.getRegionalSettings();
        vm.isChild = tripTravellerAllocationPassengerService.isChild(vm.traveller);
        vm.fullName = tripTravellerAllocationPassengerService.getTravellerFullName(vm.traveller);
        initializeInfantPassengerName();
        initializeSeatWatcher();
    }

    function initializeSeatWatcher() {
        $scope.$watch(
            () => selectedSeatsService.getSelectionModel(vm.traveller, vm.flight, vm.selectedSeats),
            handleSeatsChange,
            true
        );
    }

    function handleSeatsChange(seat) {
        vm.isSeatSelected = selectedSeatsService.isSeatSelected(vm.traveller, vm.flight, vm.selectedSeats);
        vm.isFFNSelected = !!selectedSeatsService.getSelectedFFN(vm.traveller, vm.flight, vm.selectedSeats);
        vm.seat = seat;
    }

    function deselectSeat() {
        amadeusSeatmapService.deselectOnOpenedSeatMap(vm.selectedSeats, vm.traveller, vm.flight, vm.map);
    }

    function initializeInfantPassengerName() {
        const traveller = tripTravellerAllocationPassengerService.getInfantThisPassengerTravellingWith(vm.traveller, vm.tripDetails);
        vm.travellingWithInfant = tripTravellerAllocationPassengerService.getTravellerFullName(traveller);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/flights/passenger-seat/passenger-seat-component.js